const initialState = {
  shiftsData: [],
  employeeShiftsData: [],
  loading: false,
  error: null,
};

const shiftApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...state,
        loading: action.payload,
      };

    case "GET_SHIFTS_SUCCESS":
      return {
        ...state,
        shiftsData: action.payload,
        error: null,
      };
    case "GET_SHIFTS_FAILURE":
      return {
        ...state,
        error: action.payload.error,
      };

    case "ADD_SHIFT_SUCCESS":
    case "UPDATE_SHIFT_SUCCESS":
    case "DELETE_SHIFT_SUCCESS":
      return {
        ...state,
        error: null,
      };
    case "ADD_SHIFT_FAILURE":
    case "UPDATE_SHIFT_FAILURE":
    case "DELETE_SHIFT_FAILURE":
      return {
        ...state,
        error: action.payload.error,
      };

    case "GET_EMPLOYEE_SHIFTS_SUCCESS":
      return {
        ...state,
        employeeShiftsData: action.payload,
        error: null,
      };
    case "GET_EMPLOYEE_SHIFTS_FAILURE":
      return {
        ...state,
        error: action.payload.error,
      };

    case "ASSIGN_SHIFT_SUCCESS":
    case "UPDATE_ASSIGNED_SHIFT_SUCCESS":
    case "DELETE_ASSIGNED_SHIFT_SUCCESS":
      return {
        ...state,
        error: null,
      };
    case "ASSIGN_SHIFT_FAILURE":
    case "UPDATE_ASSIGNED_SHIFT_FAILURE":
    case "DELETE_ASSIGNED_SHIFT_FAILURE":
      return {
        ...state,
        error: action.payload.error,
      };

    default:
      return state;
  }
};

export default shiftApiReducer;
